module.exports = __webpack_public_path__ + "86aec964b7876150f54b184f8072ac1b.svg";